import React from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import Layout from "./Layout/Layout";
import NetworkDetector from "../components/Hoc/NetworkDetector";
import Login from "../pages/login/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ForgetPassword from "../pages/ForgotPassword/ForgotPassword";
import VerifyOtp from "../pages/verifyOtp/VerifyOtp";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import { useLoader } from "../context/LoaderContext";
import Loader from "./Loader/Loader";
import StoreLogin from "../pages/StoreLogin/StoreLogin";
import DeepLinkHandler from "./DeepLinking";
import { getCookie } from "../context/useCookies";
import DeepLinkWithFlutterwavePaymentStatus from "./PaymentHandler/DeepLinkWithFlutterwavePaymentStatus";
import SocialPostPage from "../pages/SocialPage/SocialPostPage";
import OrderNavigation from "../pages/OrdersManagement/OrderNavigation";

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route
          path="/app/*"
          element={
            <>
              <LoaderWrapper />
              <PrivateRoute component={Layout} />
            </>
          }
        />
        <Route
          path="/login"
          element={
            <>
              <LoaderWrapper />
              <PublicRoute component={Login} />
            </>
          }
        />
        <Route
          path="/forgotPassword"
          element={
            <>
              <LoaderWrapper />
              <ForgetPassword />
            </>
          }
        />
        <Route
          path="/verifyOtp"
          element={
            <>
              <LoaderWrapper />
              <VerifyOtp />
            </>
          }
        />
        <Route
          path="/ResetPassword"
          element={
            <>
              <LoaderWrapper />
              <ResetPassword />
            </>
          }
        />

        {/* 🔹 Show StoreLogin alone, without LoaderWrapper */}
        <Route path="/store/login" element={<StoreLogin />} />
        <Route path="/eyision" element={<DeepLinkHandler />} />
        <Route path="/payment/flutterwave" element={<DeepLinkWithFlutterwavePaymentStatus />} />

              <Route path="/social/post/:id" element={<SocialPostPage />} />
        <Route path="/order-navigation/:redisKey" element={<OrderNavigation />} />


      </Routes>

      <ToastContainer />
    </>
  );
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = getCookie("accessToken")?.replace(/^"|"$/g, "");
  return isAuthenticated ? <Component {...rest} /> : <Navigate to="/login" />;
};

const PublicRoute = ({ component: Component, ...rest }) => {
  return <Component {...rest} />;
};

const LoaderWrapper = () => {
  const { loading } = useLoader();
  return <Loader loading={loading} />;
};

export default NetworkDetector(App);
